import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  GEOGRAPHIC_LIST_START: "GEOGRAPHIC_LIST_START",
  GEOGRAPHIC_LIST_SUCCESS: "GEOGRAPHIC_LIST_SUCCESS",
  GEOGRAPHIC_LIST_FAILED: "GEOGRAPHIC_LIST_FAILED"
};

// ============================================ Actions ========================================================

export const geographicListStart = data => ({
  type: actionType.GEOGRAPHIC_LIST_START,
  payload: data
});

export const geographicListSuccess = data => ({
  type: actionType.GEOGRAPHIC_LIST_SUCCESS,
  payload: data
});

export const geographicListFailed = data => ({
  type: actionType.GEOGRAPHIC_LIST_FAILED,
  payload: data
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null
};

export default function geographicListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.GEOGRAPHIC_LIST_START:
      return {
        ...state,
        loading: true
      };

    case actionType.GEOGRAPHIC_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case actionType.GEOGRAPHIC_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* geographicListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        geographicListSuccess({data: response.data.data.allGeographics.Geographics, totalCount: response.data.data.allGeographics.totalCount})
      );
    } else {
      messagePopup("", "Geographic Api failed", "error");
      yield put(geographicListFailed("Geographic Api failed"));
    }
  } catch (error) {
    messagePopup("", "Geographic Api failed", "error");
    yield put(geographicListFailed("Geographic Api failed"));
  }
}

export function* watchGeographicListSaga() {
  yield takeEvery(actionType.GEOGRAPHIC_LIST_START, geographicListSaga);
}
